import { startCase } from 'lodash';
import { EventType } from 'types/enums';
import { IconmoonFont } from 'vibo-ui/Icon';

const eventTypesIcon = {
  [EventType.birthday]: IconmoonFont['birthday-24'],
  [EventType.corporate]: IconmoonFont['corporate-24'],
  [EventType.mitzvah]: IconmoonFont['mitzvah-24'],
  [EventType.party]: IconmoonFont['party-24'],
  [EventType.quinceanera]: IconmoonFont['quinceanera-24'],
  [EventType.schoolDance]: IconmoonFont['schoolDance-24'],
  [EventType.sweet16]: IconmoonFont['sweet16-24'],
  [EventType.wedding]: IconmoonFont['wedding-24'],
};

export function getEventTypeIcon(type: Nullable<EventType>): any {
  // @ts-ignore
  return type ? eventTypesIcon[startCase(type)] : null;
}
